export default "__VITE_ASSET__DO6bAf_i__"